<script lang="ts">
	import Image from '$lib/components/Image.svelte';
	import Subscribe from '$lib/components/Subscribe.svelte';
	import { ArrowRight } from 'lucide-svelte';
	import Faq from './FAQ.svelte';
	import Hero from '$lib/components/Hero.svelte';
	import { route } from '$lib/routes';
	import Login from '$lib/components/Login.svelte';
</script>

<div class="mx-auto mt-0 max-w-4xl space-y-16 px-4 sm:mt-8">
	<section id="hero">
		<Hero>
			<div slot="actions" class="rounded-2xl bg-stone-100 shadow-md shadow-stone-500">
				<Login />
			</div>
		</Hero>
	</section>

	<hr class="my-8 h-px border-0 bg-gray-200 dark:bg-gray-700" />
	<section id="build-your-own-books" class="space-y-8">
		<div class="grid grid-cols-1 items-start gap-8 sm:grid-cols-2">
			<div class="col-span-2">
				<h2 class="mb-4 text-3xl font-bold">
					How it <span class="magic-text">works</span>
				</h2>

				<p class="text-xl sm:justify-self-start">
					Craft your own story with custom text and your own illustrations using generative AI.
					Describe the images you want to see and we&rsquo;ll create them for you. Add your family
					members into your stories by uploading a few photos of them.
				</p>
			</div>

			<a class="col-span-2 w-3/4 justify-center justify-self-center sm:w-1/2" href="/build-a-book">
				<video autoplay muted playsinline class="rounded-lg shadow-2xl">
					<source src="/img/book-builder.mp4" type="video/mp4" />
					Your browser does not support the video tag.
				</video>
			</a>

			<a href="#hero" class="link col-span-2 justify-self-start text-base text-base-content/50"
				>Create your first story for free</a>
		</div>
	</section>

	<hr class="my-8 h-px border-0 bg-gray-200 dark:bg-gray-700" />
	<section id="printed-and-delivered" class="space-y-8">
		<div class="grid grid-cols-1 items-start gap-8 sm:grid-cols-2">
			<div>
				<h2 class="mb-4 text-3xl font-bold">
					Printed <span class="magic-text">&amp;</span> delivered
				</h2>
				<p class="text-xl">
					Order hard cover editions of your favorite stories and we&rsquo;ll print and ship them.
					Disconnect from screens, and enjoy story time with your family.
				</p>
			</div>
			<Image
				class="mask-image mask-water sm:w-3/4"
				alt="hard cover personalized book"
				w="512px"
				src="landing/nuzzlers-printed.webp" />
			<div class=" grid grid-cols-1 items-center justify-items-center gap-8">
				<a
					class="link col-span-2 justify-self-start text-base text-base-content/50"
					href={route.root()}>
					Check out our stories<ArrowRight class="inline" />
				</a>
			</div>
		</div>
	</section>

	<hr class="my-8 h-px border-0 bg-gray-200 dark:bg-gray-700" />
	<section id="frequently-asked-questions" class="space-y-8">
		<div class="grid grid-cols-1 items-start gap-8 sm:grid-cols-2">
			<div class="col-span-2">
				<h2 class="mb-4 text-3xl font-bold">
					<span class="magic-text">Frequently</span> asked questions
				</h2>
				<Faq />
			</div>
		</div>
	</section>

	<section class="space-y-8 sm:rounded-lg"><Subscribe /></section>
</div>
